import { render } from "./Settings-VoicemailForwarding.vue?vue&type=template&id=a2351914&scoped=true"
import script from "./Settings-VoicemailForwarding.vue?vue&type=script&lang=js"
export * from "./Settings-VoicemailForwarding.vue?vue&type=script&lang=js"

import "./Settings-VoicemailForwarding.vue?vue&type=style&index=0&id=a2351914&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2351914"]])

export default __exports__